// src/theme.js
const THEME_KEY = "uc-hvac-theme";

function applyTheme(theme) {
  document.documentElement.dataset.theme = theme;

  document.querySelectorAll("[data-theme-toggle]").forEach((button) => {
    const dark = theme === "dark";
    const label = dark ? "Switch to light mode" : "Switch to dark mode";

    button.setAttribute("aria-label", label);
    button.setAttribute("aria-pressed", String(dark));
    button.setAttribute("title", label);
  });
}

export function initializeTheme() {
  let savedTheme;

  try {
    savedTheme = localStorage.getItem(THEME_KEY);
  } catch {
    // The toggle can still work for this visit.
  }

  const preferredTheme = matchMedia("(prefers-color-scheme: dark)").matches
    ? "dark"
    : "light";

  applyTheme(
    savedTheme === "dark" || savedTheme === "light"
      ? savedTheme
      : preferredTheme,
  );

  // Delegation also handles buttons inserted by the SPA router later.
  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-theme-toggle]");
    if (!button) return;

    const next =
      document.documentElement.dataset.theme === "dark" ? "light" : "dark";

    applyTheme(next);
    try {
      localStorage.setItem(THEME_KEY, next);
    } catch {}
  });
}

export function refreshThemeControls() {
  applyTheme(document.documentElement.dataset.theme || "light");
}
